import React, { useRef, useCallback } from "react";
import PropTypes from "prop-types";
import WebcamView from "react-webcam";
import { Typography, Fab } from "@material-ui/core";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";

import { allToBase64 } from "utils/imageUtils";
import { trackEventWebcamError } from "utils/gAnalyticsUtils";

import useStyles from "./useStyles";

const videoConstraints = {
  facingMode: "user",
};

const Webcam = (props) => {
  const { onCapture } = props;
  const classes = useStyles();
  const webcamRef = useRef(null);

  const handleCapture = useCallback(() => {
    const dataUri = webcamRef.current.getScreenshot();
    return allToBase64(dataUri).then(onCapture);
  }, [webcamRef]);

  const handleError = (error) => {
    trackEventWebcamError(error.message);
  };

  return (
    <div className={classes.root}>
      <WebcamView
        audio={false}
        width="100%"
        videoConstraints={videoConstraints}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        onUserMediaError={handleError}
      />
      <Typography variant="h4" align="center" className={classes.title}>
        Snap a photo
      </Typography>
      <Fab color="secondary" className={classes.button} onClick={handleCapture}>
        <PhotoCameraIcon fontSize="inherit" />
      </Fab>
    </div>
  );
};

Webcam.propTypes = {
  onCapture: PropTypes.func.isRequired,
};

export default Webcam;
